import React, { useState } from "react";
import Select from "react-select";
import { useAuthState } from "../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { RegExEmail, RegExNumbersOnly, RegExOnlyText } from "../../../../Helper/regEx/RegExOnlyText";
import { DepartmentNameDDL } from "../../../../Components/CommonDDL/DepartmentNameDDL";
import { DesignationNameDDL } from "../../../../Components/CommonDDL/DesignationDDL";
import { GenderNameDDL } from "../../../../Components/CommonDDL/GenderNameDDL";
import { DepartmentWiseEmpPostAPI } from "../../../../Helper/Redux/MasterSlice/DepartmentWiseEmpSlice";
import { AstricSign } from "../../../../Helper/AstricSign";


export default function AddEmployeePopup(props) {

    const { handleShowAddModal, handleIsPost, ShowAddModal,IsClear,setIsClear } = props
    const { flag, data } = ShowAddModal

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    const [EmployeeName, setEmployeeName] = useState(flag == 'Update' ? data.employeeName : '');
    const [MobNo, setMobNo] = useState(flag == 'Update' ? data.employeeMobile : '');
    const [EmailID, setEmailID] = useState(flag == 'Update' ? data.employeeEmail : '');

    const [DepartmentNameID, setDepartmentNameID] = useState({
        DDL: [],
        ID: flag == 'Update' ? data?.m_DepartmentMasterID : 0,
        Label: flag == 'Update' ? data?.departmentName : "Select...",
    })
    const [DesignationNameID, setDesignationNameID] = useState({
        DDL: [],
        ID: flag == 'Update' ? data?.m_DesignationMasterID : 0,
        Label: flag == 'Update' ? data?.designationName : "Select...",
    })
    const [GenderID, setGenderID] = useState({
        DDL: [],
        ID: flag == 'Update' ? data?.genderM_IndicatorMasterID : 0,
        Label: flag == 'Update' ? data?.indicatorName : "Select...",
    })

    const [IsValidText, setIsValidText] = useState(false)

    const handleCheckText = (e) => {
        setEmployeeName(e.target.value)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }

    const [IsValidNumber, setIsValidNumber] = useState(false)

    const handleCheckNumberOnly = (e) => {
        setMobNo(e.target.value)
        const IsValidNumber = RegExNumbersOnly(e.target.value)
        setIsValidNumber(IsValidNumber)
        return IsValidNumber
    }

    const [IsValidEmail, setIsValidEmail] = useState(false)

    const handleCheckEmail = (e) => {    
        setEmailID(e.target.value)
        const IsValidEmail = RegExEmail(e.target.value)
        setIsValidEmail(IsValidEmail)
        return IsValidEmail
    }

    const handleSubmit = () => {
        const data = {
            M_EmployeeMasterID: flag == 'Update' ? ShowAddModal.data.m_EmployeeMasterID : 0,
            M_DepartmentMasterID: DepartmentNameID.ID,
            M_DesignationMasterID: DesignationNameID.ID,
            EmployeeName: EmployeeName,
            EmployeeMobile: MobNo,
            EmployeeEmail: EmailID,
            GenderM_IndicatorMasterID: GenderID.ID,
            M_TableUserMasterID: UserID,
            Flag: flag,
            token: token,
            handleIsPost
        }
        dispatch(DepartmentWiseEmpPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.DepartmentWiseEmpPostData)

    const handleClear = () => {
        setIsClear(!IsClear)
        setEmployeeName('')
        setMobNo('')
        setEmailID('')
        setDepartmentNameID({
            ...DepartmentNameID,
            ID: 0,
            Label: "Select...",
        })
        setDesignationNameID({
            ...DesignationNameID,
            ID: 0,
            Label: "Select...",
        })
        setGenderID({
            ...GenderID,
            ID: 0,
            Label: "Select...",
        })
        
    }

    const handleClearCancel = () => {
        flag == 'Update' ? handleShowAddModal(false, '') : handleClear()
        // console.log("flag", flag)
    }


    return (
        <>
            <div className="modal fade show" style={{ display: "block", backgroundColor: "#00000055" }}>
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header ml-4">
                            <h5 className="modal-title" id="exampleModalLongTitle"> Department Wise Employee</h5>
                            <button onClick={() => handleShowAddModal(false, '')} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body mx-4">


                            <div className="row">
                                <div className="col-xl-6 col-lg-12">
                                    <DepartmentNameDDL
                                        DepartmentNameID={DepartmentNameID}
                                        setDepartmentNameID={setDepartmentNameID}
                                        apiFlag='Master'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        AstricSignFlag = "AstricSign"
                                    />
                                </div>
                                <div className="col-xl-6 col-lg-12">
                                    <DesignationNameDDL
                                        DesignationNameID={DesignationNameID}
                                        setDesignationNameID={setDesignationNameID}
                                        apiFlag='Master'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        AstricSignFlag = "AstricSign"
                                    />
                                </div>

                                <div className="col-xl-6 col-lg-12">
                                    <div className="form-group m-0">
                                        <label>Employee Name<span style={{ color: 'red', fontSize: 14 }}> *</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DepartmentName"
                                            placeholder="Employee Name"
                                            value={EmployeeName}
                                            onChange={(e) => handleCheckText(e)}

                                        />
                                        {
                                            IsValidText && <text style={{ color: 'red' }}>Please enter Alphabets characters only</text>
                                        }
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-12">
                                    <GenderNameDDL
                                        GenderID={GenderID}
                                        setGenderID={setGenderID}
                                        // apiFlag='Master'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                    />
                                </div>

                                <div className="col-xl-6 col-lg-12">
                                    <div className="form-group m-0">
                                        <label>Mobile No. <AstricSign/></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DepartmentName"
                                            placeholder="Mobile No"
                                            value={MobNo}
                                            onChange={(e) => handleCheckNumberOnly(e)}
                                            maxLength={10}
                                        />
                                        {
                                            IsValidNumber && <text style={{ color: 'red' }}>Please enter Numbers only</text>
                                        }
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-12">
                                    <div className="form">
                                        <label>Email ID<span style={{ color: 'red', fontSize: 14 }}> </span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="DepartmentName"
                                            placeholder="Email ID"
                                            value={EmailID}
                                            onChange={(e) => handleCheckEmail(e)}
                                        />
                                        {
                                            IsValidEmail && <text style={{ color: 'red' }}>Please enter valid Email ID</text>
                                        }
                                    </div>
                                </div>



                                <div className="col-12">
                                    <div className="form-group float-end mt-3 mt-lg-3">

                                        <button type="button" className="btn btn-outline-dark border-2 mx-2"
                                            disabled={DepartmentNameID.ID == 0 || DesignationNameID.ID == 0 || 
                                                EmployeeName == "" || MobNo == "" }
                                            onClick={handleSubmit}> {flag == 'Update' ? "Update" : "Add"}</button>

                                        <button type="button" className="btn btn-danger border-2"
                                            onClick={handleClearCancel}>
                                            {flag == 'Update' ? "Cancel" : "Clear"}
                                        </button>
                                    </div>
                                </div>

                            </div>




                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}